export const DefaultLocale = {
  everyText: 'cada',
  emptyMonths: 'cada mes',
  emptyMonthDays: 'cada día del mes',
  emptyMonthDaysShort: 'día del mes',
  emptyWeekDays: 'cada día de la semana',
  emptyWeekDaysShort: 'día de la semana',
  emptyHours: 'cada hora',
  emptyMinutes: 'cada minuto',
  emptyMinutesForHourPeriod: 'cada',
  yearOption: 'año',
  monthOption: 'mes',
  weekOption: 'semana',
  dayOption: 'día',
  hourOption: 'hora',
  minuteOption: 'minuto',
  rebootOption: 'reinicio',
  prefixPeriod: 'Cada',
  prefixMonths: 'en',
  prefixMonthDays: 'el',
  prefixWeekDays: 'el',
  prefixWeekDaysForMonthAndYearPeriod: 'y',
  prefixHours: 'a las',
  prefixMinutes: ':',
  prefixMinutesForHourPeriod: 'a las',
  suffixMinutesForHourPeriod: 'minuto(s)',
  errorInvalidCron: 'Expresión cron no válida',
  clearButtonText: 'Limpiar',
  weekDays: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ],
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  altWeekDays: [
    'DOM',
    'LUN',
    'MAR',
    'MIÉ',
    'JUE',
    'VIE',
    'SÁB',
  ],
  altMonths: [
    'ENE',
    'FEB',
    'MAR',
    'ABR',
    'MAY',
    'JUN',
    'JUL',
    'AGO',
    'SEP',
    'OCT',
    'NOV',
    'DIC',
  ],
};
